import { useCallback, useEffect, useState } from "react"

import { scheduleApi } from "@shared/apis"
import { Schedule, useSchedule } from "@shared/contexts"
import { getRef, store } from "@shared/modules"

import { useRecoilState } from "recoil"
import { BlacklistChattingRole } from "streamerChatting/enums"
import { blacklistStatusState } from "streamerChatting/store"

export const useBlock = () => {
  const [blacklistStatus, setBlacklistStatus] =
    useRecoilState(blacklistStatusState)

  const { schedule } = useSchedule()
  const scheduleKey = schedule?.key

  const isAllBlocking =
    blacklistStatus[BlacklistChattingRole.PAID_USER] &&
    blacklistStatus[BlacklistChattingRole.FREE_USER]

  useEffect(() => {
    if (!scheduleKey) return
    const blacklistChatRef = getRef("blacklist_chats").child(scheduleKey)
    blacklistChatRef.on("value", (snapshot: firebase.database.DataSnapshot) => {
      if (!snapshot.val()) return

      setBlacklistStatus(snapshot.val())
    })

    return () => {
      blacklistChatRef.off("value")
    }
  }, [scheduleKey])

  const handleToggleBlockingChat = useCallback(
    (role: BlacklistChattingRole) => {
      if (!schedule) return

      scheduleApi.blacklistChattingRole(
        schedule.id,
        role,
        role === BlacklistChattingRole.ALL
          ? !isAllBlocking
          : !blacklistStatus[role],
      )
    },
    [schedule, isAllBlocking, blacklistStatus],
  )

  const handleBlockingAll = useCallback((_schedule: Schedule) => {
    if (!_schedule) return

    scheduleApi
      .blacklistChattingRole(_schedule.id, BlacklistChattingRole.ALL, true)
      .then(() => {
        store.session.set("initBlock", "1")
      })
  }, [])

  const handleBlockingEmoticon = useCallback(
    (isEmoticon: boolean) => {
      if (!schedule) return

      scheduleApi.changeEmoticon(schedule.id, isEmoticon)
    },
    [schedule],
  )

  const handleBlockingCongratsMessage = useCallback(
    (isCongratsMessage: boolean) => {
      if (!schedule) return

      scheduleApi.changeCongratsMessage(schedule.id, isCongratsMessage)
    },
    [schedule],
  )

  return {
    isAllBlocking,
    handleToggleBlockingChat,
    handleBlockingAll,
    handleBlockingEmoticon,
    handleBlockingCongratsMessage,
  }
}
